import { BannerMode } from '../display/ui2-banner/ui2-banner.config'
import { StatusBadgeTone } from '../fields/helpers/ui2-status-badge'
import { UI2ColorTreatment, UI2Colors } from './color-names'

type SolidTreatment = Required<Pick<UI2ColorTreatment, 'background' | 'foreground'>>

export const UI2_BANNER_THEME: Record<BannerMode, SolidTreatment> = {
  success: { background: UI2Colors.GREEN_50, foreground: UI2Colors.GREEN_800 },
  info: { background: UI2Colors.BLUE_50, foreground: UI2Colors.BLUE_800 },
  warning: { background: UI2Colors.AMBER_50, foreground: UI2Colors.AMBER_900 },
  danger: { background: UI2Colors.RED_50, foreground: UI2Colors.RED_800 },
  neutral: { background: UI2Colors.GREY_100, foreground: UI2Colors.GREY_800 },
}

export const UI2_STATUS_BADGE_THEME: Record<StatusBadgeTone, SolidTreatment> = {
  success: { background: UI2Colors.GREEN_100, foreground: UI2Colors.GREEN_900 },
  info: { background: UI2Colors.BLUE_100, foreground: UI2Colors.BLUE_900 },
  warning: { background: UI2Colors.AMBER_100, foreground: UI2Colors.AMBER_900 },
  danger: { background: UI2Colors.RED_100, foreground: UI2Colors.RED_900 },
  neutral: { background: UI2Colors.GREY_200, foreground: UI2Colors.GREY_900 },
}
